export class AssignmentConstants {
  // reactive form internal structure
  public static DETAILS_SECTION = 'details';
  public static MODULE_ASSIGNMENT_NAME = 'moduleAssignmentName';
  public static START_DATE = 'startDate';
  public static END_DATE = 'endDate';
  public static SCORE_CRITERIA = 'scoreCriteria';
  public static DESCRIPTION = 'description';
  public static MODULE_ASSIGNMENT_TYPE = 'moduleAssignmentType';
  public static PAUSE_ENABLED = 'pauseEnabled';
  public static SHOW_MISSED_FACTS = 'showMissedFacts';

  public static PUBLISHED = 'Published';
  public static DRAFT = 'Draft';
  public static TESTING = 'Testing';

  public static readonly AUTOSAVE_GENERIC_DEBOUNCE = 1000;

  public static readonly SELFSERVE_LOCAL_STORAGE_ASSIGNMENT_INFO =
    'assignment_information';

  public static readonly SELFSERVE_TRANSPORMED_TEAMS_WITH_USERS =
    'teams_with_users';

  public static readonly ASSIGNMENTS_TAB = 'assignments';
  public static readonly SIMULATIONS_TAB = 'simulations';
}
